module.exports = __webpack_public_path__ + "img/icon_10.78b83c35.png";